import { render, staticRenderFns } from "./EditCanned.vue?vue&type=template&id=084e760e&scoped=true&"
import script from "./EditCanned.vue?vue&type=script&lang=js&"
export * from "./EditCanned.vue?vue&type=script&lang=js&"
import style0 from "./EditCanned.vue?vue&type=style&index=0&id=084e760e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084e760e",
  null
  
)

export default component.exports